document.addEventListener("DOMContentLoaded", function () {
    // Select all dropdown menu items
    const dropdownLinks = document.querySelectorAll("#mobile-subnav .dropdown > a");

    dropdownLinks.forEach(link => {
        // Add a click event listener to each top-level link
        link.addEventListener("click", function (e) {
            // Prevent default link behavior if it has a dropdown
            e.preventDefault();

            // Toggle the "open" class on the parent <li> to control visibility
            const parentLi = this.parentElement;
            parentLi.classList.toggle("active");

            // Optionally, close other dropdowns when one is opened
            dropdownLinks.forEach(otherLink => {
                if (otherLink !== this) {
                    otherLink.parentElement.classList.remove("open");
                }
            });
        });
    });
});